import { GetTokenSilentlyOptions } from '@auth0/auth0-react';

type TokenGetter = (options?: GetTokenSilentlyOptions) => Promise<string>;

let getTokenSilently: TokenGetter | null = null;

export const setAuth0TokenGetter = (getter: TokenGetter | null) => {
  getTokenSilently = getter;
};

// ponytail: module-level ref instead of context/DI, so non-React code
// (e.g. the RTK Query base query) can force a token refresh.
export const refreshAuth0Token = async (): Promise<string | undefined> => {
  if (!getTokenSilently) return undefined;

  try {
    return await getTokenSilently({ cacheMode: 'off' });
  } catch {
    return undefined;
  }
};
